<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center bg-login">
      <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/3 sm:m-0 m-4">
        <vx-card>
          <div slot="no-body">
            <div class="vx-row no-gutter justify-center items-center">
              <div class="vx-col sm:w-full md:w-full lg:w-full">
                <div class="px-8 pt-8">
                  <img src="https://cdn.redgirasol.com/green/LOGOS/redgirasol-black-green.png" alt="login">
                  <div class="vx-card__title mb-2">
                    <template v-if="user.days_left > 0">
                      <h4>Su contraseña esta a punto de expirar</h4>
                      <label class="pill-secondary">Días restantes: <strong>{{user.days_left}}</strong></label><br>
                      <small>
                        Puedes cambiarla ahora o dar clic en "Esperar" y cambiarla en otro momento
                      </small>
                    </template>
                    <template v-else>
                      <h4>Su contraseña ha expirado</h4>
                      <p>Por favor realice el reseteo de su contraseña a continuación</p>
                    </template>
                  </div>
                  <vx-input-group class="w-full mt-5 mb-4">
                      <vs-input
                      placeholder="Contraseña"
                      v-validate="'required'"
                      data-vv-name="password"
                      :type="passInputType1"
                      v-model.lazy="password" />
                      <template slot="append">
                      <div class="append-text btn-addon" >
                          <vs-button color="dark" @click="togglePassInputType1()" icon-pack="feather" :icon="passInputIcon1"></vs-button>
                      </div>
                      </template>
                  </vx-input-group>
                  <vx-input-group class="w-full mt-6 mb-4">
                      <vs-input
                      placeholder="Confirmar contraseña"
                      v-validate="'required'"
                      v-on:keyup.enter="doUpdatePassword"
                      data-vv-name="password_confirm"
                      :type="passInputType2"
                      v-model.lazy="password_confirm" />
                      <template slot="append">
                      <div class="append-text btn-addon" >
                          <vs-button color="dark" @click="togglePassInputType2()" icon-pack="feather" :icon="passInputIcon2"></vs-button>
                      </div>
                      </template>
                  </vx-input-group>
                  <span class="text-danger text-sm" v-if="messageError !== ''">{{messageError}}</span>
                  <div class="flex flex-wrap justify-between mb-3">
                      <vs-button v-if="user.days_left > 0" @click="$router.push('/')" color="dark" :disabled="loading" class="mb-5">Esperar</vs-button>
                      <vs-button @click="doUpdatePassword" color="success" :disabled="loading || password.length < 8 || password !== password_confirm" class="mb-5">Cambiar</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
</template>

<script lang="js">
const iconEye = "icon-eye";
const iconEyeOff = "icon-eye-off";
const textType = "text";

  export default  {
    name: 'password-expiration',
    mounted () {
      //this.user.change_password = false;
    },
    data () {
      return {
        passInputPassMode1: true,
        passInputPassMode2: true,
        password: "",
        password_confirm: "",
        messageError: "",
        loading: false,
      }
    },
    methods: {
      async doUpdatePassword(){
        try {
          let payload = {password: this.password};

          await axios.put('/api/auth/user/password', payload)
            .then((resolve) => {
              this.user.change_password = false;
              this.user.days_left = 90;
              this.$router.push('/');
            });
        }
        catch (error) {
          if (typeof error.response.data.message !== 'undefined') {
            this.messageError = error.response.data.message
          }else{
            this.messageError = 'Ha ocurrido un error inténtalo de nuevo.'
          }
        }
      },
      togglePassInputType1(){
          this.passInputPassMode1 = !this.passInputPassMode1;
      },
      togglePassInputType2(){
          this.passInputPassMode2 = !this.passInputPassMode2;
      },
    },
    computed: {
        passInputType1(){
            return this.passInputPassMode1 ? "password" : textType;
        },
        passInputIcon1(){
            return this.passInputPassMode1 ? iconEye : iconEyeOff;
        },
        passInputType2(){
            return this.passInputPassMode2 ? "password" : textType;
        },
        passInputIcon2(){
            return this.passInputPassMode2 ? iconEye : iconEyeOff;
        },
    }
}


</script>

<style scoped lang="scss">
  .src-views-admin-password-expiration {

  }
  .bg-login{
      background: rgb(203,255,0);
      background: radial-gradient(circle, rgba(203,255,0,1) 29%, rgba(40,222,24,1) 65%);
  }
</style>
